<template>
  <div class="button-add-note" @click="$emit('change')">{{ text }}</div>
</template>

<script>
export default {
  props: {
    text: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped>
.button-add-note {
  background: transparent linear-gradient(90deg, #ef8d6e 0%, #de367a 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 19px;
  opacity: 1;
  height: 37px;
  text-align: center;
  color: white;
  line-height: 2.3;
  cursor: pointer;
  font: normal normal normal 14px/17px Roboto;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>